import Vue from 'vue'

// initial state
const state = {
  count: 0,
  message: null,
  timestamp: null
}

// getters
const getters = {
  currentCount: (state) => {
    return state.count
  },
  currentMessage: (state) => {
    return state.message
  },
  currentTimestamp: (state) => {
    return state.timestamp
  }
}

const mutations = {
  execute (state, payload) {
    state.count++
    state.message = payload.message
    state.timestamp = payload.timestamp
  }
}

// actions
const actions = {
  execute: ({ commit }) => {
    Vue.axios.get(`ping`)
      .then(response => {
        Vue.$log.debug('Ping OK')
        commit({ type: 'execute', message: response.data.reply, timestamp: response.data.timestamp })
      })
      .catch(e => {
        Vue.$log.error(e)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
